import { useRecoilState } from "recoil";

import Service from "./service";
import { clickToCallAtom, ACTIVE_STATE_TYPES, INITIAL_STATE } from "./constants";

const useClickToCall = () => {
  const [state, setState] = useRecoilState(clickToCallAtom);

  const { activeCall } = state;

  function call({ agentNumber, agentName, agentContactType, userNumber, userName, lob }) {
    setState((state) => ({ ...state, agentNumber, agentName, agentContactType, userNumber, userName }));
    const payload = { agentNumber, agentName, agentContactType, userNumber, userName };
    Service.initiateCall({ payload, headers: { lob } }).then((res) => {
      const { data } = res;
      if(data.code && data.message) {
        const error = {
          title: data.title,
          message: data.message
        }
        setState((state) => ({ ...state, activeCall: null, activeState: ACTIVE_STATE_TYPES.ERROR, error }));
      } else {
        const { correlationId, status } = data;
        setState((state) => ({ ...state, activeCall: correlationId }));
      }
    })
    .catch(() => {
      setState((state) => ({ ...state, activeCall: null, activeState: ACTIVE_STATE_TYPES.ERROR, error: {} }));
    });
  }

  function updateBeforeCall({ agentNumber, agentName, agentContactType, userNumber, userName }) {
    setState((state) => ({ ...state, activeState: ACTIVE_STATE_TYPES.UPDATE, agentNumber, agentName, agentContactType, userNumber, userName }));
  }

  function maximize() {
    setState((state) => ({ ...state, activeState: ACTIVE_STATE_TYPES.CALL_MAXIMIZED }));
  }

  function minimize() {
    setState((state) => ({ ...state, activeState: ACTIVE_STATE_TYPES.CALL_MINIMIZED }));
  }

  function dismiss() {
    setState((state) => ({ ...INITIAL_STATE, activeState: ACTIVE_STATE_TYPES.DISMISSED }));
  }

  function updateCallPayload(payload) {
    setState((state) => ({ ...state, ...payload }));
  }

  return { isCallActive: !!activeCall, call, updateBeforeCall, maximize, minimize, dismiss, updateCallPayload };
};

export default useClickToCall;
